import { GET_INVENTORY_VIEW, GET_INVENTORY_VIEW_SUCCESS, GET_INVENTORY_VIEW_ERROR, GET_INVENTORY_VIEW_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetInventoryView = (state = initialState, action) => {
  switch (action.type) {
    case GET_INVENTORY_VIEW:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_INVENTORY_VIEW_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_INVENTORY_VIEW_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_INVENTORY_VIEW_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetInventoryView;
